// removed by extract-text-webpack-plugin
module.exports = {"gender-radio":"gender-radio","radio":"radio","radio-gender":"radio-gender"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/Gender/Gender.scss
// module id = l1S7
// module chunks = 0